/**
 * Microsoft Authentication Library (MSAL) configuration
 * For Microsoft OAuth integration
 */
import { getConfig } from '../config/production';

export const msalConfig = {
  auth: {
    clientId: getConfig('MICROSOFT_CLIENT_ID') || '',
    authority: `https://login.microsoftonline.com/${getConfig('MICROSOFT_TENANT_ID') || 'common'}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // Error
            console.error(message);
            return;
          case 1: // Warning
            console.warn(message);
            return;
          case 2: // Info
            console.info(message);
            return;
          case 3: // Verbose
            console.debug(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
  prompt: 'select_account'
};